export interface PostalAddress {address: string; province: string; city: string; state: string}
/** Consulta pública: somente o CEP é enviado, sem cookies ou cabeçalhos da aplicação. */
export async function lookupPostalCode(cep: string, signal: AbortSignal): Promise<PostalAddress | null> {
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {signal, credentials: 'omit', referrerPolicy: 'no-referrer'});
  if (!response.ok) throw new Error('Consulta indisponível');
  const data = await response.json();
  if (data.erro) return null;
  if (typeof data.localidade !== 'string' || typeof data.uf !== 'string') throw new Error('Endereço inválido');
  return {address: typeof data.logradouro === 'string' ? data.logradouro : '', province: typeof data.bairro === 'string' ? data.bairro : '', city: data.localidade, state: data.uf};
}
